
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class AdminModal extends Vue {
  public deleting: boolean = false;

  public closeModal() {
    this.$store.commit('setModal', '');
  }

  public deleteAllProfiles() {
    this.deleting = true;
    try {
      this.$store.dispatch('deleteAllProfiles');
    } catch (e) {
      this.$store.commit('setToastError', 'Error deleting profiles');
    }
    this.deleting = false;
  }
}

